import { gql } from 'graphql-request';

export const getIncidentTitlesQuery = gql`
  query GetIncidentTitlesForAgentMerge(
    $filters: IncidentV2BaseFilters
    $limit: Int
  ) {
    incidentsV2Paged(filters: $filters, limit: $limit) {
      items {
        id
        title
      }
    }
  }
`;
